<div class="container-fluid">
  <div class="row">
    <div class="col-xl-6" [ngStyle]="{'background-image': 'url(assets/images/login/logo_login.png)',
                                      'background-size': 'cover',
                                      'background-position': 'center center',
                                      'display': 'block'}">
      <img class="bg-img-cover bg-center d-none" src="assets/images/login/logo_login.png" alt="looginpage">
    </div>
    <div class="col-xl-6 p-0">
      <div class="login-card">
        <div>
          <div>
            <a class="logo" routerLink='/'>
              <img class="img-fluid for-light" src="assets/images/login/logo1.png" width="300" alt="looginpage">
              <img class="img-fluid for-dark" src="assets/images/login/logo1.png" width="300" alt="looginpage">
            </a>
          </div>
          <div class="login-main">
            <form class="theme-form needs-validation" [class.was-validated]="!loginForm.valid" novalidate=""
              [formGroup]="loginForm">
              <h4 style="color: #003557;">Inicia Sesión</h4>
              <div class="form-group">
                <label class="col-form-label">Usuario</label>
                <input class="form-control" type="text" required="" placeholder="Ingresá tu usuario"
                  formControlName="username">
                <div class="invalid-tooltip"
                  *ngIf="loginForm.controls.username.touched && loginForm.controls.username.errors?.required">El Usuario
                  es
                  necesario.</div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Contraseña</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" name="login[password]" required=""
                  placeholder="*********" formControlName="password">
                <div class="invalid-tooltip"
                  *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required">La
                  Contraseña es necesaria.</div>
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
              </div>
              <div class="form-group mb-0">
                <a [routerLink]="'/forgot-password'" class="link" style="color: #003557;">Olvidé mi
                  contraseña</a><br><br>
                <button class="btn btn-primary btn-pill d-block w-100" type="button" [disabled]="!loginForm.valid"
                  (click)="login()">Login</button>
              </div>
              <p class="mt-4 mb-0" style="color: #62bcc5;">Aun no eres paciente?
                <a [routerLink]="'/register'" class="ms-2" style="color: #003557;">Crea tu cuenta</a><br>
              </p>
              <p class="mt-4 mb-0" style="color: #62bcc5;">Olvidé mi nombre de usuario
                <a [routerLink]="'/forgot-mail'" class="ms-2" style="color: #003557;">Recuperar usuario</a><br>
              </p>
            </form>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 footer-copyright text-center">
            <p class="mb-0">Pedernera 312, San Luis, Argentina</p> 
            <p>Copyright © Centro Visión SL </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>